// extracted by mini-css-extract-plugin
export var borderlessSpinnerContainer = "_3j-2";
export var closeIcon = "_3j-6";
export var filterItem = "_3j-4";
export var normalCellWithAdjustableBorder = "_3j-5";
export var spinner = "_3j-0";
export var spinnerContainer = "_3j-1";
export var tableContainer = "_3j-3";